/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiEntitySchemaField } from './InternalApiEntitySchemaField';
import {
    InternalApiEntitySchemaFieldFromJSON,
    InternalApiEntitySchemaFieldFromJSONTyped,
    InternalApiEntitySchemaFieldToJSON,
    InternalApiEntitySchemaFieldToJSONTyped,
} from './InternalApiEntitySchemaField';

/**
 * a Schema
 * @export
 * @interface InternalApiEntitySchema
 */
export interface InternalApiEntitySchema {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiEntitySchema
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {Array<InternalApiEntitySchemaField>}
     * @memberof InternalApiEntitySchema
     */
    schemaFields: Array<InternalApiEntitySchemaField>;
}



/**
 * Check if a given object implements the InternalApiEntitySchema interface.
 */
export function instanceOfInternalApiEntitySchema(value: object): value is InternalApiEntitySchema {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('schemaFields' in value) || value['schemaFields'] === undefined) return false;
    return true;
}

export function InternalApiEntitySchemaFromJSON(json: any): InternalApiEntitySchema {
    return InternalApiEntitySchemaFromJSONTyped(json, false);
}

export function InternalApiEntitySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntitySchema {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'schemaFields': ((json['schemaFields'] as Array<any>).map(InternalApiEntitySchemaFieldFromJSON)),
    };
}

export function InternalApiEntitySchemaToJSON(json: any): InternalApiEntitySchema {
    return InternalApiEntitySchemaToJSONTyped(json, false);
}

export function InternalApiEntitySchemaToJSONTyped(value?: InternalApiEntitySchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'schemaFields': ((value['schemaFields'] as Array<any>).map(InternalApiEntitySchemaFieldToJSON)),
    };
}

